import { render, staticRenderFns } from "./ChangelogModal.vue?vue&type=template&id=651e7156&scoped=true&"
import script from "./ChangelogModal.vue?vue&type=script&lang=ts&"
export * from "./ChangelogModal.vue?vue&type=script&lang=ts&"
import style0 from "./ChangelogModal.vue?vue&type=style&index=0&id=651e7156&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651e7156",
  null
  
)

export default component.exports